import React, {useState} from 'react';
import PropTypes from 'prop-types';

const TherapyProjectCreator = ({
    onCreate,
    onClose
}) => {
    const [aiUsageLoading, setAiUsageLoading] = useState(false);
    const [error, setError] = useState('');
    const [creditUsage, setCreditUsage] = useState(null);

   const handleCreate = async () => {
    setAiUsageLoading(true);
    setError('');
    setCreditUsage(null);

    try {
        console.log(
            '[THERAPY MODAL] Starting create...'
        );

        const result = await onCreate();

        console.log(
            '[THERAPY MODAL] onCreate returned:',
            result
        );

        if (result) {
            setCreditUsage(result);

            console.log(
                '[THERAPY MODAL] creditUsage state being set:',
                result
            );
        } else {
            console.warn(
                '[THERAPY MODAL] onCreate returned no creditUsage.'
            );
        }
    } catch (err) {
        console.error(
            '[THERAPY MODAL] Therapy Project creation failed:',
            err
        );

        if (
            err &&
            (
                err.code === 'functions/failed-precondition' ||
                err.code === 'failed-precondition'
            )
        ) {
            setError(
                'You do not have enough AI Credits to create this project.'
            );
        } else {
            setError(
                err.message ||
                'Unable to create the Therapy Project. Please try again.'
            );
        }
    } finally {
        setAiUsageLoading(false);
    }
};

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <button
                    type="button"
                    aria-label="Close"
                    onClick={onClose}
                    style={{
                        ...styles.closeButton,
                        ...(aiUsageLoading ?
                            styles.disabledButton :
                            {})
                    }}
                    disabled={aiUsageLoading}
                >
                    ×
                </button>

                <div style={styles.header}>
                    <div style={styles.eyebrow}>
                        ✨ AI THERAPY PROJECT
                    </div>

                    <h2 style={styles.title}>
                        Create a Complete Therapy Activity
                    </h2>

                    <p style={styles.subtitle}>
                        Build a ready-to-use interactive therapy activity
                        with AI-generated characters, a backdrop, therapy
                        rounds, and session tools.
                    </p>
                </div>

                <div style={styles.creditCard}>
                    <div style={styles.creditTopRow}>
                        <div>
                            <div style={styles.creditTitle}>
                                ✨ AI Therapy Project
                            </div>

                            <div style={styles.creditDescription}>
                                One complete AI-generated activity
                            </div>
                        </div>

                        <div style={styles.creditBadges}>
                            <div style={styles.creditBadge}>
                                <strong>5</strong>
                                <span style={styles.badgeLabel}>
                                    CREDITS
                                </span>
                            </div>

                            <div style={styles.freeBadge}>
                                <strong>2</strong>
                                <span style={styles.badgeLabel}>
                                    FREE
                                </span>
                            </div>
                        </div>
                    </div>

                    <div style={styles.freeMessage}>
                        Your first 2 AI Therapy Projects are free.
                    </div>

                    <div style={styles.afterFree}>
                        After your free projects · 5 AI Credits each
                    </div>
                </div>

                <div style={styles.includesCard}>
                    <div style={styles.includesTitle}>
                        A complete project can include:
                    </div>

                    <div style={styles.feature}>
                        <span style={styles.check}>✓</span>
                        <span>
                            Therapy activity and lesson structure
                        </span>
                    </div>

                    <div style={styles.feature}>
                        <span style={styles.check}>✓</span>
                        <span>
                            Up to 10 AI-generated characters
                        </span>
                    </div>

                    <div style={styles.feature}>
                        <span style={styles.check}>✓</span>
                        <span>
                            AI-generated backdrop
                        </span>
                    </div>

                    <div style={styles.feature}>
                        <span style={styles.check}>✓</span>
                        <span>
                            Multiple therapy rounds
                        </span>
                    </div>

                    <div style={styles.feature}>
                        <span style={styles.check}>✓</span>
                        <span>
                            Interactive scoring and session tools
                        </span>
                    </div>
                </div>

                <div style={styles.infoCard}>
                    <div style={styles.infoIcon}>
                        💡
                    </div>

                    <div>
                        <strong>
                            One project. One price.
                        </strong>

                        <div style={styles.infoText}>
                            Characters and backdrops created as part of
                            the Therapy Project are included in the
                            project cost.
                        </div>
                    </div>
                </div>

                {creditUsage && (
                    <div style={styles.usageResult}>
                        <span style={styles.successIcon}>
                            ✓
                        </span>

                        <div style={styles.usageContent}>
                            <div style={styles.usageTitle}>
                                {creditUsage.freeUse ?
                                    'Free Therapy Project used' :
                                    `${creditUsage.creditsUsed} AI ${
                                        creditUsage.creditsUsed === 1 ?
                                            'Credit' :
                                            'Credits'
                                    } used`
                                }
                            </div>

                            <div style={styles.usageDetails}>
                                {
                                    creditUsage
                                        .freeScratchProjectsRemaining
                                }
                                {' free remaining · '}
                                {creditUsage.aiCredits}
                                {' AI '}
                                {creditUsage.aiCredits === 1 ?
                                    'Credit' :
                                    'Credits'
                                }
                                {' remaining'}
                            </div>
                        </div>
                    </div>
                )}

                {error && (
                    <div style={styles.error}>
                        <span style={styles.errorIcon}>
                            !
                        </span>

                        <span>
                            {error}
                        </span>
                    </div>
                )}

                {aiUsageLoading && (
                    <div style={styles.loadingMessage}>
                        <span style={styles.loadingIcon}>
                            ✨
                        </span>

                        <div>
                            <strong>
                                Creating your Therapy Project...
                            </strong>

                            <div style={styles.loadingText}>
                                This can take a little time while the
                                activity and AI assets are generated.
                            </div>
                        </div>
                    </div>
                )}

                <div style={styles.actions}>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            ...styles.cancelButton,
                            ...(aiUsageLoading ?
                                styles.disabledButton :
                                {})
                        }}
                        disabled={aiUsageLoading}
                    >
                        {creditUsage ? 'Close' : 'Cancel'}
                    </button>

                    {!creditUsage && (
                        <button
                            type="button"
                            onClick={handleCreate}
                            style={{
                                ...styles.createButton,
                                ...(aiUsageLoading ?
                                    styles.disabledButton :
                                    {})
                            }}
                            disabled={aiUsageLoading}
                        >
                            {aiUsageLoading ?
                                '✨ Creating Project...' :
                                '✨ Create Project'
                            }
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        background: 'rgba(0, 0, 0, 0.48)'
    },

    modal: {
        position: 'relative',
        width: '100%',
        maxWidth: '520px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxSizing: 'border-box',
        padding: '26px',
        borderRadius: '16px',
        background: '#ffffff',
        boxShadow: '0 18px 50px rgba(0, 0, 0, 0.25)',
        color: '#333333'
    },

    closeButton: {
        position: 'absolute',
        top: '12px',
        right: '14px',
        width: '32px',
        height: '32px',
        padding: 0,
        border: 'none',
        borderRadius: '50%',
        background: '#f3f4f6',
        color: '#555555',
        cursor: 'pointer',
        fontSize: '22px',
        lineHeight: '30px'
    },

    header: {
        paddingRight: '28px',
        marginBottom: '18px'
    },

    eyebrow: {
        marginBottom: '7px',
        color: '#6b46d9',
        fontSize: '11px',
        fontWeight: 'bold',
        letterSpacing: '0.8px'
    },

    title: {
        margin: '0 0 8px',
        fontSize: '22px',
        lineHeight: 1.2,
        color: '#2f2f2f'
    },

    subtitle: {
        margin: 0,
        color: '#666666',
        fontSize: '13px',
        lineHeight: 1.5
    },

    creditCard: {
        marginBottom: '14px',
        padding: '16px',
        border: '1px solid #ddd6fe',
        borderRadius: '12px',
        background: '#f7f5ff'
    },

    creditTopRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '14px'
    },

    creditTitle: {
        marginBottom: '3px',
        color: '#4c1d95',
        fontSize: '14px',
        fontWeight: 'bold'
    },

    creditDescription: {
        color: '#6b7280',
        fontSize: '11px'
    },

    creditBadges: {
        display: 'flex',
        gap: '7px',
        flexShrink: 0
    },

    creditBadge: {
        minWidth: '54px',
        padding: '7px 8px',
        borderRadius: '9px',
        background: '#6b46d9',
        color: '#ffffff',
        textAlign: 'center'
    },

    freeBadge: {
        minWidth: '54px',
        padding: '7px 8px',
        borderRadius: '9px',
        background: '#dcfce7',
        color: '#166534',
        textAlign: 'center'
    },

    badgeLabel: {
        display: 'block',
        marginTop: '1px',
        fontSize: '8px'
    },

    freeMessage: {
        marginTop: '13px',
        color: '#374151',
        fontSize: '12px',
        fontWeight: 'bold'
    },

    afterFree: {
        marginTop: '4px',
        color: '#6b7280',
        fontSize: '11px'
    },

    includesCard: {
        marginBottom: '14px',
        padding: '15px',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        background: '#ffffff'
    },

    includesTitle: {
        marginBottom: '10px',
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#374151'
    },

    feature: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: '7px',
        color: '#4b5563',
        fontSize: '12px'
    },

    check: {
        color: '#16a34a',
        fontWeight: 'bold'
    },

    infoCard: {
        display: 'flex',
        gap: '10px',
        marginBottom: '20px',
        padding: '12px',
        borderRadius: '10px',
        background: '#f9fafb',
        color: '#374151',
        fontSize: '12px'
    },

    infoIcon: {
        fontSize: '18px'
    },

    infoText: {
        marginTop: '3px',
        color: '#6b7280',
        lineHeight: 1.4
    },

    usageResult: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '14px',
        padding: '10px 12px',
        border: '1px solid #cbe6d2',
        borderRadius: '10px',
        background: '#f4fbf6'
    },

    usageContent: {
        minWidth: 0
    },

    successIcon: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: '#d8f2df',
        color: '#26763b',
        fontSize: '12px',
        fontWeight: '900'
    },

    usageTitle: {
        color: '#28623a',
        fontSize: '12px',
        fontWeight: 'bold'
    },

    usageDetails: {
        marginTop: '2px',
        color: '#66806c',
        fontSize: '10px'
    },

    error: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '14px',
        padding: '10px 12px',
        border: '1px solid #f2c6ca',
        borderRadius: '10px',
        background: '#fff6f7',
        color: '#a73b45',
        fontSize: '11px',
        lineHeight: 1.4
    },

    errorIcon: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        background: '#a73b45',
        color: '#ffffff',
        fontSize: '10px',
        fontWeight: 'bold'
    },

    loadingMessage: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '14px',
        padding: '11px 12px',
        border: '1px solid #ddd6fe',
        borderRadius: '10px',
        background: '#f7f5ff',
        color: '#4c1d95',
        fontSize: '11px'
    },

    loadingIcon: {
        flexShrink: 0,
        fontSize: '18px'
    },

    loadingText: {
        marginTop: '2px',
        color: '#6b7280',
        fontSize: '10px',
        lineHeight: 1.4
    },

    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px'
    },

    cancelButton: {
        padding: '10px 16px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        background: '#ffffff',
        color: '#4b5563',
        cursor: 'pointer',
        fontWeight: 'bold'
    },

    createButton: {
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        background: '#6b46d9',
        color: '#ffffff',
        cursor: 'pointer',
        fontWeight: 'bold'
    },

    disabledButton: {
        opacity: 0.55,
        cursor: 'default'
    }
};

TherapyProjectCreator.propTypes = {
    onCreate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export default TherapyProjectCreator;